var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightMode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.465 18.7709C23.635 18.3659 23.1492 18.0209 22.7417 18.2009C21.927 18.5581 21.047 18.7419 20.1575 18.7409C16.67 18.7409 13.8433 15.9709 13.8433 12.5534C13.843 11.3996 14.1707 10.2696 14.7883 9.29505C15.025 8.92172 14.7408 8.40505 14.3075 8.51505C10.9667 9.36755 8.5 12.3442 8.5 15.885C8.5 20.0909 11.9792 23.5 16.2717 23.5C19.5217 23.5 22.305 21.5459 23.465 18.7709Z",
    fill: "#2F80ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0094 8.58591C18.5678 8.29091 18.0411 8.81757 18.3353 9.25924L18.8603 10.0467C19.0734 10.366 19.1872 10.7412 19.1872 11.1251C19.1872 11.5089 19.0734 11.8842 18.8603 12.2034L18.3353 12.9909C18.0411 13.4326 18.5686 13.9592 19.0103 13.6642L19.7969 13.1392C20.1161 12.9261 20.4914 12.8123 20.8753 12.8123C21.2591 12.8123 21.6344 12.9261 21.9536 13.1392L22.7411 13.6642C23.1828 13.9592 23.7094 13.4326 23.4144 12.9909L22.8894 12.2034C22.6762 11.8842 22.5625 11.5089 22.5625 11.1251C22.5625 10.7412 22.6762 10.366 22.8894 10.0467L23.4144 9.25924C23.7094 8.81757 23.1828 8.29091 22.7403 8.58591L21.9536 9.11091C21.6344 9.32409 21.2591 9.43787 20.8753 9.43787C20.4914 9.43787 20.1161 9.32409 19.7969 9.11091L19.0094 8.58591Z",
    fill: "#2F80ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightMode);
export default __webpack_public_path__ + "static/media/lightMode.8a3f2ebd275c759867ff93e8b09a1f9d.svg";
export { ForwardRef as ReactComponent };